<div id="globeContainer" #globeContainer class="rounded-2"></div>
